module.exports = __webpack_public_path__ + "img/ic-aim-point.3e208e2e.svg";